import isFirstMessage from "./isFirstMessage";

export default function (type, campaignIsInbound) {
  if (campaignIsInbound) {
    return false;
  }

  return isFirstMessage(type);
}
